import { useQuery } from "@tanstack/react-query";

import { getFeatureFlags } from "../api/endpoints/feature-flags/feature-flags";
import type { ResolvedFlags } from "../api/models";

/**
 * Feature flags resolvidas para o usuário autenticado (`GET /feature-flags`).
 * Requer sessão — não use em telas públicas.
 */
export function useFeatureFlags() {
  return useQuery<ResolvedFlags>({
    queryKey: ["feature-flags"],
    queryFn: async () => {
      const response = await getFeatureFlags();
      return response.data.data;
    },
    staleTime: 60_000,
    retry: false,
  });
}

/** Libera a seção de indicação na área logada. */
export function isReferralViewEnabled(flags?: ResolvedFlags): boolean {
  return flags?.account?.referral?.view === true;
}
